import { DOCUMENTS_TYPES } from '../../FileUpload/FileUpload.constants';

export const NAMES = {
  SECOND_DOCUMENT_INPUT: 'SecDocInput',
  DRIVER_LICENSE: 'driverLicense',
  INTERNATIONAL_PASSPORT: 'internationalPassport',
  MILITARY_ID: 'militaryID',
  TAX_REGISTRATION: 'taxRegistration',
  SNILS: 'snils',
  ISSUE_DATE: 'issueDate',
};

export const SYS_NAMES = {
  SECOND_PENSION: '2nd_pension',
  SECOND_FOREIGN_PASSPORT: '2nd_foreign_passport',
  SECOND_TAX: '2nd_tax',
  SECOND_MILITARY: '2nd_military',
  SECOND_DRIVER: '2nd_driver',
};

export const SECOND_DOCUMENT_TRUST = [
  DOCUMENTS_TYPES.DRIVER_LICENCE,
  DOCUMENTS_TYPES.SNILS,
  DOCUMENTS_TYPES.INN,
  DOCUMENTS_TYPES.INTERNATIONAL_PASSPORT,
  DOCUMENTS_TYPES.MILITARY_ID,
];

export const SECOND_DOCUMENT_FORM_LABELS = {
  [NAMES.SECOND_DOCUMENT_INPUT]: 'Серия, номер',
  [NAMES.ISSUE_DATE]: 'Дата выдачи',
};
